import { useState, useEffect } from "react";
import { MondayApiQueryInstance } from "../../services/monday/monday-service-ts";
import { getUsersBackend } from "../../utils/requests/getUsersBackend";
import useTokenHook from "../context/useTokenHook";
import logger from "../../lib/logger";
import useUser from "../context/userHook";

interface User {
  id: number;
  name: string;
  email: string;
  status: boolean;
}

const useFetchUserStatus = (pageSize = 500, searchTerm = "") => {
  const { accountId } = useUser();
  const { token } = useTokenHook();
  const [users, setUsers] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchAllUsers = async (searchTerm: string) => {
    setIsLoading(true);
    setError(false);
    try {
      let allUsers: any[] = [];
      let currentPage = 1;
      let hasMoreData = true;

      while (hasMoreData) {
        const response: any = await MondayApiQueryInstance.getUsers(pageSize, currentPage, searchTerm);

        const fetchedUsers = response || [];
        allUsers = [...allUsers, ...fetchedUsers];

        // Check if more data exists
        if (fetchedUsers.length < pageSize) {
          hasMoreData = false;
        } else {
          currentPage++;
        }
      }

      const backendResponse: any = await getUsersBackend(token!, accountId!);

      const updatedUsers: User[] = allUsers.map((user: any) => ({
        ...user,
        status: backendResponse?.data?.data?.some((dbUser: any) => dbUser.userid === user.id),
      }));

      setUsers(updatedUsers);
    } catch (err: any) {
      setError(true);
      logger.error("Error fetching users:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchAllUsers(searchTerm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, searchTerm]);

  return {
    users,
    isLoading,
    error,
    fetchAllUsers,
  };
};

export default useFetchUserStatus;
